// UI store, game side (IMPLEMENTATION §2.1 ui/store.ts): the GameController publishes a snapshot at 10 Hz
// (game/snapshot.ts); the chrome reads these signals. The shell's own UI state (panels, toasts, Sarge, the
// intro) lives beside it in ui/state.ts (M7). The HUD numbers are derived here: headline = total/s at all
// times, and from u18 the smoothed "auto $X/s" line (L12).
import { signal } from '@preact/signals';
import type { UiSnapshot } from '../game/snapshot.ts';
import { createRateSmoother, type RateSmoother } from './hudRate.ts';

export interface HudView {
  cash: number;
  /** Headline rate: total $/s. */
  total: number;
  /** Secondary line: smoothed automated $/s, or null before u18. */
  auto: number | null;
}

export const snapshotSig = signal<UiSnapshot | null>(null);
export const hudSig = signal<HudView | null>(null);

let smoother: RateSmoother | null = null;

/** ui.json hud.autoSmoothSec (set once at boot). */
export function configureHud(autoSmoothSec: number): void {
  smoother = createRateSmoother(autoSmoothSec);
}

export function publishSnapshot(s: UiSnapshot, nowMs: number): void {
  snapshotSig.value = s;
  let auto: number | null = null;
  if (s.income.showAuto && smoother)
    auto = Math.floor(smoother.update(s.income.autoYoungPerSec, nowMs));
  else smoother?.reset();
  const prev = hudSig.value;
  const next: HudView = { cash: s.cash, total: s.income.totalPerSec, auto };
  if (!prev || prev.cash !== next.cash || prev.total !== next.total || prev.auto !== next.auto)
    hudSig.value = next;
}
